import { render, staticRenderFns } from "./CustomNotifications.vue?vue&type=template&id=d94c0892&scoped=true"
import script from "./CustomNotifications.vue?vue&type=script&lang=js"
export * from "./CustomNotifications.vue?vue&type=script&lang=js"
import style0 from "./CustomNotifications.vue?vue&type=style&index=0&id=d94c0892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94c0892",
  null
  
)

export default component.exports